import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';
import {
    TextStyleCategory,
    TextStyleColor,
    TextStyleSize,
    TextStyleVariant,
    textStyleClass,
    textStyleColorClass,
} from '@sirius/typography';

@Component({
    selector: 'sirius-text-html',
    template: `
        <div [class]="textClass()" [attr.itemprop]="itemprop()" [innerHTML]="cleanHtml()"></div>
    `,
    styleUrls: ['text-html.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        'class': 'sir-text-html',
        '[class.sir-text-html--s]': "textStyleSize() === 's'",
        '[class.sir-text-html--m]': "textStyleSize() === 'm'",
        '[class.sir-text-html--l]': "textStyleSize() === 'l'",
        '[class.sir-text-html--clamped]': 'lineClamp() !== undefined',
        '[style.--sir-text-html-line-clamp]': 'lineClamp()',
    }
})
export class TextHtmlComponent {
    readonly html = input<string | null>('');
    readonly itemprop = input<string | undefined>();
    readonly textStyle = input<TextStyleCategory>('paragraph');
    readonly textStyleSize = input<TextStyleSize>('m');
    readonly textStyleVariant = input<TextStyleVariant>('default');
    readonly textStyleColor = input<TextStyleColor>('primary');
    /**
     * When set, clamps the rendered HTML to N lines with an ellipsis.
     * Leave unset to disable clamping.
     */
    readonly lineClamp = input<number | undefined>(undefined);

    readonly cleanHtml = computed(() =>
        (this.html() ?? '').replace(/<p><code>\s*<\/code><\/p>/g, '')
    );

    /** Typography utility classes for the rendered HTML container (ADR 0001). */
    readonly textClass = computed(
        () =>
            `${textStyleClass(this.textStyle(), this.textStyleSize(), this.textStyleVariant())} ${textStyleColorClass(
                this.textStyleColor()
            )}`
    );
}
